import { MicrositeCustomTheme, MicrositeTheme } from 'types';
import { baseTheme } from '../baseTheme';

// ==================================
// BEGIN CUSTOM THEMING FOR MICROSITE
// ==================================

const customTheme: MicrositeCustomTheme = {
  name: 'RealPageTheme',
  code: 'RealPage',
  colors: {
    headerBackground: '#F9F9F9', // header not shown for Embed
    headerText: '#222222', // header not shown for Embed
    headerBorder: '#E5E5E5', // header not shown for Embed
    background: '#F9F7F7',
    footerBackground: '#F9F9F9', // footer not shown for Embed
    footerText: '#222222', // footer not shown for Embed
    footerBorder: '#E5E5E5', // footer not shown for Embed
    progressBar: '#282829',
  },
  logoSize: {
    width: '1px', // header logo not shown for Embed
    height: '1px', // header logo not shown for Embed
  },
  baseColors: {
    link: '#3957E1',
    cta: '#282829',
    hover: '#030304',
  },
};

// ==================================
// END CUSTOM THEMING FOR MICROSITE
// ==================================

const mergedTheme = Object.assign(baseTheme, {
  colors: {
    ...baseTheme.colors,
    ...customTheme.baseColors,
  },
});

export const RealPageTheme: MicrositeTheme = {
  ...mergedTheme,
  customTheme,
};
